import React, { useEffect, useState } from "react";
import HtmlHead from "../components/html-head/HtmlHead";
import { Link, useNavigate } from "react-router-dom";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import RightMenu from "./components/RightMenu";
import ModalComponent from "./components/ModalComponent";
import { ApiService } from "../helpers/services/apiSrevice";
import AlertService from "../helpers/services/alertService";
import { setIsShowLoader } from "../store/reducers/loaderReducer";
import MainService from "../helpers/services/mainService";
import moment from "moment/moment";
import { setIsOpenRightMenu } from "../store/reducers/menuReducer";
import { FaArrowLeft } from "react-icons/fa6";

const Account = () => {
	const title = "Личный Кабинет";
	const description = "";
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { user } = useSelector(state => state.user);
	const [isShowModal, setIsShowModal] = useState(false);
	const [isShowLoading, setIsShowLoading] = useState(false);
	const [oldPassword, setOldPassword] = useState('');
	const [password, setPassword] = useState('');
	const [additionalField, setAdditionalField] = useState('');
	const [courses, setCourses] = useState([]);
	const [history, setHistory] = useState([]);

	useEffect(() => {
		if (!user) {
			navigate("/");
		}
	}, [user])


	useEffect(() => {
		getAccountPageData();
	}, [])

	const getAccountPageData = () => {
		dispatch(setIsShowLoader(true));
		MainService.callApi({
			api: ApiService.getAccountPageData,
			cb: response => {
				if (response && response.data) {
					setCourses(response.data.courses || [])
					setHistory(response.data.history || [])
					setAdditionalField(response.data.additionalField || "")
				}
			},
			getFail: error => navigate("/logout"),
			_finally: () => {
				setTimeout(() => {
					dispatch(setIsShowLoader(false));
				}, 1000);
			}
		});
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		if (password.trim().length && oldPassword.trim().length) {
			const data = {
				oldPassword: btoa(oldPassword),
				password: btoa(password),
			}
			setIsShowLoading(true);
			MainService.callApi({
				api: ApiService.changePassword,
				data: data,
				cb: () => {
					AlertService.alert("success", "Пароль успешно изменён!");
				},
				_finally: () => {
					cancel();
				}
			});
		}
	};

	const formatName = (fullName) => {
		if (!fullName) return "";

		const parts = fullName.trim().split(/\s+/);
		const firstName = parts[0];

		if (parts.length === 1) {
			return capitalize(firstName);
		}

		const initials = parts
			.slice(1)
			.map(word => word.charAt(0).toUpperCase() + '.')
			.join(' ');

		return `${capitalize(firstName)} ${initials}`;
	}

	const capitalize = (word) => {
		return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
	}

	const cancel = () => {
		setIsShowLoading(false);
		setIsShowModal(false);
		setPassword("");
		setOldPassword("");
	}

	return (
		<>
			<ModalComponent isOpen={isShowModal} onClose={cancel}>
				<form onSubmit={handleSubmit}>
					<div className="bg-white mb-5 p-4 px-4 radius-20" style={{ fontSize: 'initial' }}>
						<h3 className="mb-3">Сменить пароль</h3>
						<div className="mb-3">
							<label>Старый пароль</label>
							<input
								type="password"
								value={oldPassword}
								onChange={(e) => setOldPassword(e.target.value)}
								required
								className="form-input"
								style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #ccc' }}
							/>
						</div>

						<div className="mb-4">
							<label>Новый пароль</label>
							<input
								type="password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								required
								className="form-input"
								style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #ccc' }}
							/>
						</div>

						<Button type="submit" className="submit-button radius-20" disabled={isShowLoading}>
							{isShowLoading ? 'Загрузка...' : 'Сменить пароль'}
						</Button>
					</div>
				</form>
			</ModalComponent>

			<div className="account">
				<HtmlHead title={title} description={description} />
				<RightMenu>
					<div>
						<Link
							to="#"
							className="link text-nowrap"
							onClick={() => {
								setIsShowModal(true);
								dispatch(setIsOpenRightMenu(false))
							}}
						>
							сменить пароль
						</Link>
					</div>
				</RightMenu>

				<Container>
					<div className="account-header-md d-block d-lg-none">
						<div className="name-block-md">
							<div className="d-flex gap-3 align-items-center">
								<h4 className="account-header-title">
									Напишите нам:
								</h4>
								<div className="sociallinks d-flex gap-2">
									<a href="https://wa.me/+79252872077" target="_blank">
										<img src="/icons/dark_whatsapp.svg" />
									</a>
									<a href="https://t.me/govoroksupport" target="_blank">
										<img src="/icons/dark_telegram.svg" />
									</a>
								</div>
							</div>
							<div className="name">
								{formatName(user?.fullName)}
							</div>
						</div>
					</div>
					<div className="account-header d-none d-lg-block">

						<div className="account-header-first-column">
							<Link
								to="/"
								className="header-button text-nowrap back-button d-flex gap-1 align-items-center">
								<FaArrowLeft size={18} className="mt-1" />
								<span>на главную</span>
							</Link>

							<div className="name-block gap-3">
								<h4 className="account-header-title">
									Напишите нам:
								</h4>
								<div className="my-3 sociallinks d-flex gap-2">
									<a href="https://wa.me/+79951161843" target="_blank">
										<img src="/icons/dark_whatsapp.svg" />
									</a>
									<a href="https://t.me/govoroksupport" target="_blank">
										<img src="/icons/dark_telegram.svg" />
									</a>
								</div>
								<div className="line"></div>
								<div className="name">
									{formatName(user?.fullName)}
								</div>
							</div>
						</div>
					</div>
					<Row className="pb-5 main-content">
						<Col lg={8} className="mt-3 mt-lg-0">
							<h3 className="account-title mb-3">Мои курсы</h3>
							<div className=" radius-50 p-3 pt-4 bg-white">
								<Row>
									<Col sm={12} className="mb-5">
										<div className="ms-3">
											<div className="d-flex align-items-center gap-3">
												<span className="section-title">{courses.length}</span>
												<img src="/images/clock.svg" />
											</div>
											<span className="section-sub-title d-block">активных</span>
										</div>
									</Col>
									<Col sm={12}>
										<Row>
											{
												courses && courses.length ?
													courses.map((item, index) => {
														return <Col key={index} md={6} className="mt-2">
															<div className={`course-block ${index % 2 === 0 ? "course-1" : "course-2"} radius-50 p-2`} onClick={() => navigate(`/course-content/${item.id}`)}>
																<div className="d-flex flex-column h-100 justify-content-between">
																	<div>
																		<span className="date">от {moment(item.acquiredDate).format("DD.MM.YYYY")}</span>
																		<h3 className="course-title">
																			{item.title.split(" ").map((word, idx) => (
																				<span key={idx} className="d-block">{word}</span>
																			))}
																		</h3>
																	</div>
																	<div className="d-flex justify-content-end me-3 mb-2">
																		<span className="radius-50 deadline px-3 ms-auto">
																			{
																				item.remainingDays ? `дней осталось: ${item.remainingDays}` : "навсегда"
																			}
																		</span>
																	</div>
																</div>
															</div>
														</Col>
													})
													: null
											}
										</Row>
									</Col>

								</Row>
							</div>
							{
								additionalField ?
									<div className="info-block">
										<p className="mb-0">
											{additionalField}
										</p>
									</div>
									: null
							}
						</Col>
						<Col lg={4} className="mt-3 mt-lg-0">
							<div className="mb-5  d-none d-lg-block">
								<Link
									to="#"
									className="header-button text-nowrap back-button d-flex align-items-center"
									style={{ width: "min-content", color: "#222222" }}
									onClick={() => {
										setIsShowModal(true)
									}}
								>
									<span>сменить пароль</span>
								</Link>
								<Link
									to="/logout"
									className="header-button text-nowrap back-button d-flex align-items-center mt-2" style={{ width: "min-content", color: "#222222", }}>
									<span>выйти</span>
								</Link>

							</div>
							{
								history && history.length ?
									<div className="radius-50  pt-3 chat">
										<p className="chat-title">История</p>
										<div className="chat-items">
											{
												history.map((item, index) => {
													return <div key={index} className={`chat-block ${index % 2 === 0 ? "chat-block-1" : "chat-block-2"} my-3 p-3 radius-20`}>
														{
															item.eventDate ?
																<p className="date">{moment(item.eventDate).format("DD.MM.YYYY")}</p>
																: null
														}
														<p className="text">{item.eventDescription}</p>
													</div>
												})
											}
										</div>
									</div>
									: null
							}

						</Col>
					</Row>
				</Container>
			</div>
		</>

	);
};

export default Account;
